module.exports = __webpack_public_path__ + "static/media/Slide65.2bdb2af6.JPG";